export function transitionGuard() {
  window.isTransitioning = true;
  setTimeout(() => {
    window.isTransitioning = false;
  }, 500);
}
